module.exports = __webpack_public_path__ + "images/Booksdfed413f4db6533690a5ac8c71da3066.png";